
import { Link } from "react-router-dom"

import {useMediaQuery} from "beautiful-react-hooks";


export default function Footer() {

    const isSmall = useMediaQuery('(max-width: 768px)')


    return(
        <>

<div className="bottom section-padding pt-0 pb-0 backfooter">
                    <div className="container">
                    {isSmall ?

                    
                            <>

                            <div className="mt-3">
                            <div className="bottom-logo">
                                    <div className="row rlogo-56121 mb-3">
                                    <img className={'logo-desk-css22'} src={'./images/white-logo.svg'} alt={'صرافی ارز دیجیتال سینا تتر'}/>

                                    


                                    </div>

                                    <div className="row">



                                    <div className="col-6">

                                    <div className="css-tel324">
                                    <a href={'/prize-exchange'}>

                                    <div class="text-white hndsf12400" 
                                    >صرافی جایزه دار</div>
                                                     
                                    </a>

                                    <a href={'/leverage-crypto-currencies'}>


                                                    <div class="text-white hndsf12400" 
                                    > ارز های لوریج دار</div>
                                    </a>


                                    <a href={'/about'}>
                                                     

                                    <div class="text-white hndsf12400" 
                                    >درباره ما  </div>

                                    </a>

                                    </div>
                                                     
                        

                               </div>


                               <div className="col-6">
                               <div className="col-xl-2 col-lg-4 col-md-6 col-sm-6 ">
                            <div className="bottom-widget">
                                    <h4 className="widget-title">ما را دنبال کنید</h4>
                                    <ul className="d-flex">
                                        <li><a href="https://instagram.com/sinatether">
                                        <i class="fa fa-instagram " aria-hidden="true"></i>
                                        <span class="pl-1 pr-1 pb-1 pt-1">
                                                             

                                                </span>
                                            
                                            
                                            </a></li>
                                        <li><a href="https://t.me/sinatether">  

                                        <i class="fa fa-telegram " aria-hidden="true"></i>
                                        <span class="pl-1 pr-1 pb-1 pt-1">

                                                </span>
                                        
                                          </a></li>
                                        <li><a to="#">  

                                        <i class="fa fa-twitter " aria-hidden="true"></i>
                                        <span class="pl-1 pr-1 pb-1 pt-1">

                                                </span>
                                        
                                         </a></li>
                                    </ul>
                                    <span class="text-white m16px ">پشتیبانی:</span>
                                                        <span className="css-tel313242424"
                                                        
                                                    >91693606</span>
                                </div>
                               
                            </div>

</div>


                               </div>
                                </div>
                            </div>



                            <div className="row">

                            <div className="col-6">
                            <div className="bottom-widget">
                                    <h4 className="widget-title"> تبدیل ارز </h4>
                                    <div className="row">
                                        <div className="col-xl-12 col-lg-6 col-md-6 col-sm-6 ">
                                            <ul>
                                                <li><Link to="/USDT">تبدیل تومان به تتر</Link></li>
                                                <li><Link to="/BTC"> تبدیل تتر به بیت کوین</Link></li>
                                                <li><Link to="/ETH">تبدیل بیت کوین به اتریوم</Link></li>
                                            </ul>
                                        </div>
                                        
                                    </div>
                                </div>
                                
                            </div>
                            <div className="col-6 ">
                            <div className="bottom-widget">
                                    <h4 className="widget-title">آموزش و امکانات</h4>
                                    <ul>
                                        <li><Link to="/learnAuth"> آموزش احرازهویت</Link></li>
                                        <li><Link to="/buysell"> آموزش خرید و فروش</Link></li>
                                        <li><Link to="#">آموزش واریز و برداشت </Link></li>
                                    </ul>
                                </div>
                                
                            </div>

                            </div>

                                                        
                                                        
                                                        
                                                        
                            </>


                            :

                        <div className="row mt-5">

                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
                                <div className="bottom-logo">
                                    <div className="row rlogo-56121">
                                    <img className={'logo-desk-css22'} src={'./images/white-logo.svg'} alt={'صرافی ارز دیجیتال سینا تتر'}/>

                                    


                                    </div>

                                    <div className="css-tel324">
                                                        <span class="text-white m16px ">پشتیبانی:</span>
                                                        <span className="css-tel313242424"
                                                        
                                                    >021-91693606</span>
                                                    </div>
                               <div className="w-100 mb-5">
                                   
                                   <span className="text-white m16px ">
                                   آدرس: تهران، آرژانتین،ساعی، احمد قصیر، محجوبی 18 ، ساختمان جردن،
                                   طبقه سوم واحد 19
                                   </span>
                                   


                               </div>

                                </div>
                            </div>
                            <div className="col-xl-2 col-lg-2 col-md-6 col-sm-6 ">
                            <div className="bottom-widget">
                                    <h4 className="widget-title">آموزش و امکانات</h4>
                                    <ul>
                                        <li><Link to="/learnAuth"> آموزش احرازهویت</Link></li>
                                        <li><Link to="/buysell"> آموزش خرید و فروش</Link></li>
                                        <li><Link to="#">آموزش واریز و برداشت </Link></li>
                                    </ul>
                                </div>
                                
                            </div>
                            <div className="col-xl-2 col-lg-2 col-md-6 col-sm-6">
                            <div className="bottom-widget">
                                    <h4 className="widget-title"> تبدیل ارز </h4>
                                    <div className="row">
                                        <div className="col-xl-12 col-lg-6 col-md-6 col-sm-6 ">
                                            <ul>
                                                <li><Link to="/USDT">تبدیل تومان به تتر</Link></li>
                                                <li><Link to="/BTC"> تبدیل تتر به بیت کوین</Link></li>
                                                <li><Link to="/ETH">تبدیل بیت کوین به اتریوم</Link></li>
                                            </ul>
                                        </div>
                                        
                                    </div>
                                </div>
                                
                            </div>
                            <div className="col-xl-2 col-lg-4 col-md-6 col-sm-6 ">
                            <div className="bottom-widget">
                                    <h4 className="widget-title">شبکه های اجتماعی</h4>
                                    <ul>
                                        <li><a href="https://instagram.com/sinatether">
                                        <i class="fa fa-instagram " aria-hidden="true"></i>
                                        <span class="pl-1 pr-1 pb-1 pt-1">
                                                             اینستاگرام

                                                </span>
                                            
                                            
                                            </a></li>
                                        <li><a href="https://t.me/sinatether">  

                                        <i class="fa fa-telegram " aria-hidden="true"></i>
                                        <span class="pl-1 pr-1 pb-1 pt-1">
                                                             تلگرام

                                                </span>
                                        
                                          </a></li>
                                        <li><a to="#">  

                                        <i class="fa fa-twitter " aria-hidden="true"></i>
                                        <span class="pl-1 pr-1 pb-1 pt-1">
                                                             توییتر

                                                </span>
                                        
                                         </a></li>
                                    </ul>
                                </div>
                               
                            </div>


                            
                        </div>

                    }


                        <div className=" fo7878 mfksrhnr text-center">
                                تمامی حقوق مادی و معنوی این وبسایت متعلق به شرکت سینا تتر می باشد.

                                </div>
                    </div>
                </div>

        
        </>
    )
}